let API_URL = "";

if (process.env.NODE_ENV === 'production') {
    API_URL = 'https://app.mfuko.net/api/v1' //Production
} else {
    API_URL = 'http://localhost:8000/api/v1' //development
}

export { API_URL }